import { render } from "./PushInfo.vue?vue&type=template&id=055faa8e&scoped=true"
import script from "./PushInfo.vue?vue&type=script&lang=js"
export * from "./PushInfo.vue?vue&type=script&lang=js"

import "./PushInfo.vue?vue&type=style&index=0&id=055faa8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055faa8e"]])

export default __exports__